import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

const useStyles = createStyles(({ token, css }: any) => ({
  section: css`
    background: ${token.ColorFigmaNeutralGrayscaleGray10};
  `,
  body: css``,
}));

export const useTableCanceledStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
